import DataAccess from './constants';
import API from './API'
const path = 'customeraddresses';

let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const GetCustomersAddress = (customer) => {
    let newpath = path + "?CustomerIDList=" + customer.customerIdList;
    return api.getData(newpath)
}